export const mdThemes = [
  "smartblue",
  "cyanosis",
  "channing-cyan",
  "fancy",
  "hydrogen",
  "condensed-night-purple",
  "greenwillow",
  "v-green",
  "vue-pro",
  "healer-readable",
  "mk-cute",
  "jzman",
  "geek-black",
  "awesome-green",
  "orange",
  "scrolls",
  "simplicity-green",
  "arknights",
  "vuepress",
  "Chinese-red",
  "nico",
  "devui-blue",
];